import { enGB, frFR, nlNL } from '@lessonup/translations';
import { Resource } from 'i18next';

export const translationResources: Resource = {
  en: enGB,
  nl: nlNL,
  fr: frFR,
};
